export function differenceInHoursAndMinutes(init, finish) {
  const timeDiffMs = finish.getTime() - init.getTime()

  const diffMinutes = Math.floor(timeDiffMs / (1000 * 60))

  const hours = Math.floor(diffMinutes / 60)
  const minutes = diffMinutes % 60

  if (hours === 0) {
    return `${minutes.toString().padStart(2, '0')} minutos`
  }

  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')} hs`
}

export const isExpired = (date) => {
  if (date) {
    const expirationTime = new Date(date).getTime()
    const nowTime = new Date().getTime()

    if (nowTime > expirationTime) {
      return true
    }
  }

  return false
}
